import { createFileRoute } from '@tanstack/react-router';
import { Tabs } from 'antd';
import { evaluateAdminOnlyAccess, requireAdminAccess } from '../../../features/admin';
import { DomainsPanel, InvitesPanel } from '../../../features/admin/access/components';

const AccessPage = () => (
  <Tabs
    defaultActiveKey="domains"
    items={[
      { key: 'domains', label: 'Allowed Domains', children: <DomainsPanel /> },
      { key: 'invites', label: 'Email Invites', children: <InvitesPanel /> },
    ]}
  />
);

export const Route = createFileRoute('/_auth/admin/access')({
  beforeLoad: requireAdminAccess(evaluateAdminOnlyAccess),
  component: AccessPage,
});
